// Conversion tracking hook for ad platforms (Google Ads / GA4).
//
// No measurement IDs are hardcoded here: events are pushed to window.dataLayer
// (and window.gtag when present), so the hook is a safe no-op until the owner
// installs a real gtag/GTM snippet. Once the snippet exists, the
// "booking_completed" event starts flowing automatically.
//
// Duplicate protection: the event fires exactly once per booking reference,
// even if the user refreshes or revisits /booking-confirmed.

const FIRED_KEY = "wtd_conversion_fired";

export function trackBookingConversion(booking) {
  if (!booking?.ref) return false;

  let fired = [];
  try {
    fired = JSON.parse(sessionStorage.getItem(FIRED_KEY) || "[]");
  } catch {
    fired = [];
  }
  if (fired.includes(booking.ref)) return false; // refresh never re-fires

  const payload = {
    booking_reference: booking.ref,
    currency: "CAD",
    ...(typeof booking.total === "number" ? { value: booking.total } : {}),
    ...(booking.service_name ? { services: booking.service_name } : {}),
  };

  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "booking_completed", ...payload });
    if (typeof window.gtag === "function") {
      window.gtag("event", "booking_completed", payload);
    }
  }

  try {
    sessionStorage.setItem(FIRED_KEY, JSON.stringify([...fired, booking.ref].slice(-20)));
  } catch {
    /* storage blocked — event already pushed, worst case it fires once more */
  }
  return true;
}
